module.exports = __webpack_public_path__ + "img/2.a400c79a.jpg";